<template>
    <patternlib-headline headline="Silent-Refresh"></patternlib-headline>
</template>

<style lang="scss" scoped>
</style>